import React from "react";
import * as R from "ramda";
import { Box, Flex, Divider } from "@chakra-ui/react";

import { MaxWidth } from "components/Container";
import { TiliaLogo } from "components/Logos";
import { useSessionJWT } from "utils";

const getUsername = R.prop("username");

export const Header = () => {
  const { sessionData } = useSessionJWT();
  return (
    <header>
      <MaxWidth py={6}>
        <Flex direction="row" justify="space-between">
          <Box>
            <TiliaLogo size="sm" />
          </Box>
          <Box>{getUsername(sessionData)}</Box>
        </Flex>
      </MaxWidth>
      <Divider />
    </header>
  );
};
